/*
  Complete Your Set — index enhancement.

  The cards are already on the page with the honest first-visit figures:
  nothing owned. This only *corrects* them for someone with a saved checklist. If this file fails to load, or throws, the page still reads
  correctly — it just shows the same thing it shows a new visitor. That is the
  point, and it is why nothing here builds DOM.

  This is a port of progressFromCounts() from the prototype. Its counterpart,
  progressFor(), works from real slots on the checklist page. The two MUST
  agree — they were checked against each other at 7/264 and 3% on Evolving
  Skies, and that is the number to re-check against if either changes. The
  third figure they were checked on, £163.85 to finish, was removed from both
  screens on 2026-08-23 for reading as a price quote.
*/

(function () {
  'use strict'

  var root = document.querySelector('[data-set-index]')
  if (!root) return

  var src = root.getAttribute('data-src')
  if (!src) return

  fetch(src)
    .then(function (r) { return r.json() })
    .then(apply)
    .catch(function () {
      /* Leave the server-rendered figures alone. A visitor with no checklist
         sees the correct numbers anyway, and one with a checklist sees the
         full set rather than a broken page. */
    })

  function apply(data) {
    var owned = readOwned(data.storageKey)
    if (!owned) return

    /*
      `prices` is no longer used to total anything — it is the list of printings
      that exist, and a slot id naming one that does not is not counted. Keep it
      for that even though no money is displayed any more.
    */
    var prices = data.prices
    var cards = root.querySelectorAll('[data-set]')
    for (var i = 0; i < cards.length; i++) update(cards[i], owned, prices)
  }

  /** Slot ids look like `bulk:swsh7:1:reverse`. */
  function readOwned(key) {
    try {
      var raw = localStorage.getItem(key)
      if (!raw) return null
      var list = JSON.parse(raw)
      if (!Array.isArray(list) || !list.length) return null
      var set = Object.create(null)
      for (var i = 0; i < list.length; i++) set[list[i]] = true
      return set
    } catch (e) {
      // Private browsing, a full quota, or corrupted JSON. Not worth breaking
      // the page over.
      return null
    }
  }

  function update(card, owned, prices) {
    var setId = card.getAttribute('data-set')
    var total = Number(card.getAttribute('data-total'))
    var prefix = 'bulk:' + setId + ':'

    var ownedCount = 0
    for (var id in owned) {
      if (id.lastIndexOf(prefix, 0) !== 0) continue
      var parts = id.split(':') // bulk, setId, number, variant
      var variant = parts[3]
      if (!prices[variant]) continue
      ownedCount++
    }

    var missing = Math.max(0, total - ownedCount)
    var percent = total === 0 ? 0 : Math.round((ownedCount / total) * 100)

    setText(card, '[data-owned]', String(ownedCount))
    setText(card, '[data-percent]', percent + '%')
    // How many printings are still unticked. Deliberately NOT a stock claim —
    // see the note in scripts/build-set-data.mjs.
    setText(card, '[data-available]', String(missing))

    var ring = card.querySelector('[data-ring]')
    if (ring) {
      var circumference = Number(ring.getAttribute('stroke-dasharray'))
      ring.setAttribute('stroke-dashoffset', String(circumference * (1 - percent / 100)))
    }

    if (percent === 100) card.classList.add('set-card--done')
  }

  function setText(scope, selector, value) {
    var el = scope.querySelector(selector)
    if (el) el.textContent = value
  }

})()
